// Funtion
import adjustViewport from './function/adjustViewport'
import debounce from './function/debounce';

// Module
import SmoothScroll from './module/SmoothScroll';
import DrawerMenu from './module/DrawerMenu';
import HeartAnimation from './module/HeartAnimation';
import ScrollAnimation from './module/ScrollAnimation';
import PeopleModal from './module/PeopleModal';
import Accordion from './module/Accordion';
import FormValidation from './module/FormValidation';
import CommonModal from './module/CommonModal';

const init = () => {

  (() => {
    const debouncedFunction = debounce(() => {
      adjustViewport();
    });
    window.addEventListener('resize', debouncedFunction, false);
    adjustViewport();
  })();

  // SmoothScrollより先に実行しないと、リンククリック時に該当箇所にスクロールしない
  (() => {
    const drawerMenu = new DrawerMenu();
    drawerMenu.init();
  })();

  (() => {
    const heartAnimation = new HeartAnimation();
    heartAnimation.init();
  })();

  (() => {
    const scrollAnimation = new ScrollAnimation();
    scrollAnimation.init();
  })();

  (() => {
    const smoothScroll = new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
    smoothScroll.init();
  })();

  (() => {
    const peopleModal = new PeopleModal();
    peopleModal.init();
  })();

  (() => {
    const accordion = new Accordion();
    accordion.init();
  })();

  (() => {
    const formValidation = new FormValidation();
    formValidation.init();
  })();

  (() => {
    const commonModal = new CommonModal();
    commonModal.init();
  })();

};

window.addEventListener('DOMContentLoaded', () => {
  init();
});